export const getTournamentImageStyles = (
  isTablet: boolean,
  imgUrl: string | null
) => {
  if (!imgUrl) {
    return null
  }

  if (isTablet) {
    return {
      backgroundColor: '#2C313B',
      backgroundImage: [
        'linear-gradient(180deg, rgba(20, 22, 26, 0.35) 0%, rgba(20, 22, 26, 0.85) 100%)',
        'linear-gradient(360deg, #14161A 0%, rgba(20, 22, 26, 0) 32.54%)',
        `url(${imgUrl})`
      ].join(', '),
      backgroundSize: 'auto, auto, cover',
      backgroundPosition: 'center, center, center',
      backgroundRepeat: 'no-repeat, no-repeat, no-repeat'
    }
  }

  return {
    backgroundColor: '#2C313B',
    backgroundImage: `url(${imgUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center, center, center',
    backgroundRepeat: 'no-repeat, no-repeat, no-repeat'
  }
}
